/**
 * CareSettingTable — Section 3: Average Response Time by Care Setting.
 */

const CareSettingTable = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="ex-section">
            <h3 className="ex-section__title">Average Response Time by Care Setting</h3>
            <div className="ap-table-container">
                <div className="dp-table-wrap">
                    <table className="dp-table">
                        <thead className="dp-thead">
                            <tr>
                                <th scope="col" className="ap-th"><div className="ap-th__content"><span>Care Setting</span></div></th>
                                <th scope="col" className="ap-th"><div className="ap-th__content"><span>Avg Response Time (min)</span></div></th>
                                <th scope="col" className="ap-th"><div className="ap-th__content"><span>Total Alarms</span></div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, idx) => (
                                <tr key={idx} className="dp-tr">
                                    <td className="dp-td">{row.area_type_name || '--'}</td>
                                    <td className="dp-td">{row.avg_response_time != null ? Number(row.avg_response_time).toLocaleString(undefined, { maximumFractionDigits: 1 }) : '--'}</td>
                                    <td className="dp-td">{row.total_events != null ? Number(row.total_events).toLocaleString() : '0'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CareSettingTable;
